module.exports = __webpack_public_path__ + "static/img/l_1_2.79a3173.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/assets/image/My/l_1_2.png
// module id = ll6e
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18